import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import qs from 'query-string';

// Material UI
import { withStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiChip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';

import useGetAllCategories from 'src/hooks/api/categories/useGetAllCategories';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { IChildCategory, IParentCategory } from '../../../../interface';

const ChipContainer = styled.div`
  display: flex;
  margin-top: 5px;
  //max-width: 100%;
`;
const Chip = styled(MuiChip)`
  margin-left: 5px;
  font-size: 10px !important;
  background: ${({ theme }) => theme.colors.primary} !important;
  max-width: 100px;
`;
const CategoryPanelContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  .MuiFormControl-root {
    margin-top: 10px;
  }
`;
const PanelHeading = withStyles({
  h6: {
    width: '100%',
    fontWeight: 'normal',
    fontSize: '13px',
  },
})(Typography);
const ExpansionPanel = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);
const CategoryPanelSummary = withStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
})(ExpansionPanelSummary);
type CategoryPanel = {
  isWantedSearch: boolean;
};
const CategoryPanel = ({ isWantedSearch }: CategoryPanel) => {
  const router = useRouter();
  const { query } = router;
  const { Categories } = useGetAllCategories();
  const [parentCategory, setParentCategory] = useState<IParentCategory | null>(null);
  const [childCategories, setChildCategories] = useState<IChildCategory[] | null>(null);
  const [childCategory, setChildCategory] = useState<IChildCategory | null>(null);

  const handleParentSelect = (event: any) => {
    const filteredCat =
      (Categories && Categories.filter((item) => item.slug === event.target.value)[0]) || [];
    setParentCategory(filteredCat);
    setChildCategories((filteredCat && filteredCat.children) || []);
    query.parent_cat = event.target.value;
    if (isWantedSearch) {
      router.push(`/wanted-search?${qs.stringify(query)}`);
    } else {
      router.push(`/search?${qs.stringify(query)}`);
    }
  };

  const handleChildSelect = (event: any) => {
    const childFilteredCat =
      (childCategories && childCategories?.filter((item) => item.slug === event.target.value)[0]) ||
      null;
    setChildCategory(childFilteredCat);
    query.child_cat = event.target.value;
    if (isWantedSearch) {
      router.push(`/wanted-search?${qs.stringify(query)}`);
    } else {
      router.push(`/search?${qs.stringify(query)}`);
    }
  };

  const onDeleteParentCategoryHandler = () => {
    setParentCategory(null);
    setChildCategory(null);
    delete query.child_cat;
    delete query.parent_cat;
    if (isWantedSearch) {
      router.push(`/wanted-search?${qs.stringify(query)}`);
    } else {
      router.push(`/search?${qs.stringify(query)}`);
    }
  };

  const onDeleteChildCategoryHandler = () => {
    setChildCategory(null);
    delete query.child_cat;
    if (isWantedSearch) {
      router.push(`/wanted-search?${qs.stringify(query)}`);
    } else {
      router.push(`/search?${qs.stringify(query)}`);
    }
  };
  const [expanded, setExpanded] = React.useState(true);

  const handlePanelChange = (event: any, isExpanded: boolean) => {
    setExpanded(!!isExpanded);
  };

  useEffect(() => {
    if (Categories && query.parent_cat) {
      const filtered =
        (Categories && Categories.filter((item) => item.slug === query.parent_cat)[0]) || null;
      if (filtered) {
        setParentCategory(filtered);
        setChildCategories(filtered.children);
      }
    }
  }, [Categories, query.parent_cat]);
  return (
    <ExpansionPanel defaultExpanded expanded={expanded} onChange={handlePanelChange}>
      <CategoryPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <PanelHeading variant="h6">By Category</PanelHeading>
        <ChipContainer>
          {parentCategory && (
            <Chip
              label={parentCategory && parentCategory.name}
              onDelete={onDeleteParentCategoryHandler}
              color="primary"
            />
          )}
          {childCategory && (
            <Chip
              label={childCategory && childCategory.name}
              onDelete={onDeleteChildCategoryHandler}
              color="primary"
            />
          )}
        </ChipContainer>
      </CategoryPanelSummary>
      <ExpansionPanelDetails>
        <CategoryPanelContent>
          <FormControl variant="outlined">
            <InputLabel id="ParentCategory">Parent category</InputLabel>
            <Select
              labelId="ParentCategory"
              id="ParentCategory"
              value={(parentCategory && parentCategory.slug) || ''}
              onChange={handleParentSelect}
              label="Parent category"
            >
              <MenuItem value="" disabled>
                <em>Select Parent Category</em>
              </MenuItem>
              {Categories &&
                Categories.map((category, index) => {
                  return (
                    <MenuItem key={index} value={category.slug}>
                      {category.name}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
          <FormControl variant="outlined">
            <InputLabel id="childCategory">Child category</InputLabel>
            <Select
              labelId="childCategory"
              id="childCategory"
              value={(childCategory && childCategory.slug) || ''}
              name="childCategory"
              onChange={handleChildSelect}
              label="Child category"
            >
              <MenuItem value="" disabled>
                <em>Select Child Category</em>
              </MenuItem>
              {childCategories &&
                childCategories.map((cat, index) => {
                  return (
                    <MenuItem key={index} value={cat.slug}>
                      {cat.name}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </CategoryPanelContent>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default CategoryPanel;
